export default __webpack_public_path__ + "img/android-chrome-512x512.bc134f56.png";